import axios from "axios";
import * as types from "./types";

export default {
  async [types.GET_CSAT_SURVEY]({ commit }, idOrToken) {
    const { data } = await axios.get(`/api/csat/${idOrToken}`);
    commit(types.CSAT_SURVEY, data.data ?? data); // Resource or plain
  },

  async [types.SET_CSAT_SURVEY]({ }, { idOrToken, score, text }) {
    return axios.post(`/api/csat/${idOrToken}/answers`, { score, text });
  },
};
